import CreatedMessages from "./CreatedMessages";
export default CreatedMessages;